import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconFileText = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.3333 3H13.5554C13.7617 3 13.9595 3.0862 14.1054 3.23964L18.772 8.14873C18.9178 8.30217 18.9998 8.51028 18.9998 8.72727V18.5455C18.9998 19.9011 17.9551 21 16.6665 21H7.3333C6.04465 21 5 19.9011 5 18.5455V5.45455C5 4.09894 6.04465 3 7.3333 3ZM17.4439 9.067L13.2321 4.63632H7.33294C6.90339 4.63632 6.55518 5.00263 6.55518 5.4545V18.5454C6.55518 18.9973 6.90339 19.3636 7.33294 19.3636H16.6661C17.0957 19.3636 17.4439 18.9973 17.4439 18.5454V9.067Z"
        />
        <path d="M13.5556 3C13.9494 3 14.2748 3.3078 14.3263 3.70716L14.3334 3.81818L14.3334 7.90909H18.2222C18.6159 7.90909 18.9414 8.2169 18.9929 8.61625L19 8.72727C19 9.14149 18.7074 9.48381 18.3277 9.53799L18.2222 9.54545H13.5556C13.1618 9.54545 12.8364 9.23765 12.7849 8.8383L12.7778 8.72727V3.81818C12.7778 3.36631 13.126 3 13.5556 3Z" />
        <path d="M15.1112 12.7637C15.5408 12.7637 15.889 13.13 15.889 13.5819C15.889 13.9961 15.5964 14.3384 15.2168 14.3926L15.1112 14.4H8.88909C8.45955 14.4 8.11133 14.0337 8.11133 13.5819C8.11133 13.1676 8.40393 12.8253 8.78356 12.7711L8.88909 12.7637H15.1112Z" />
        <path d="M15.1112 15.8C15.5408 15.8 15.889 16.1664 15.889 16.6182C15.889 17.0324 15.5964 17.3748 15.2168 17.4289L15.1112 17.4364H8.88909C8.45955 17.4364 8.11133 17.0701 8.11133 16.6182C8.11133 16.204 8.40393 15.8617 8.78356 15.8075L8.88909 15.8H15.1112Z" />
        <path d="M10.4446 9.72729C10.8742 9.72729 11.2224 10.0936 11.2224 10.5455C11.2224 10.9597 10.9298 11.302 10.5502 11.3562L10.4446 11.3637H8.88909C8.45955 11.3637 8.11133 10.9973 8.11133 10.5455C8.11133 10.1313 8.40393 9.78894 8.78356 9.73476L8.88909 9.72729H10.4446Z" />
      </svg>
    );
  }
);
